import * as RadixSwitch from '@radix-ui/react-switch';
import styles from './Switch.module.css';

type RadixSwitchProps = React.ComponentProps<typeof RadixSwitch.Root>;

export type SwitchProps = RadixSwitchProps;

export function Switch({ className, ...props }: SwitchProps) {
  return (
    <RadixSwitch.Root className={`${styles.root} ${className ?? ''}`} {...props}>
      <RadixSwitch.Thumb className={styles.thumb} />
    </RadixSwitch.Root>
  );
}
